<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
    import {
        PaginationEllipsis,
        PaginationList,
        PaginationListItem,
        PaginationNext,
        PaginationPrev,
        PaginationRoot,
    } from 'reka-ui';
    import { watch } from 'vue';
    import type { Table } from '@tanstack/vue-table';

    const props = defineProps<{
        table: Table<any>;
        totalRecords: number;
    }>();
</script>

<template>
    <PaginationRoot
        :total="totalRecords"
        :sibling-count="1"
        :items-per-page="table.getState().pagination.pageSize"
        @update:page="table.setPageIndex($event - 1)"
        show-edges
        :page="table.getState().pagination.pageIndex + 1"
    >
        <PaginationList
            v-slot="{ items }"
            class="border-input flex items-center rounded-md border shadow-xs [&>button]:rounded-none [&>button]:border-r [&>button]:last:border-r-0"
        >
            <PaginationPrev as-child>
                <Button
                    variant="ghost_primary"
                    size="icon"
                >
                    <ChevronLeft />
                </Button>
            </PaginationPrev>
            <template v-for="(page, index) in items">
                <PaginationListItem
                    v-if="page.type === 'page'"
                    :key="index"
                    class="data-[selected]:bg-background! hidden sm:flex"
                    :value="page.value"
                    as-child
                >
                    <Button
                        variant="ghost_primary"
                        size="icon"
                    >
                        {{ page.value }}
                    </Button>
                </PaginationListItem>
                <PaginationEllipsis
                    v-else
                    :key="page.type"
                    class="hidden sm:flex"
                    :index="index"
                    as-child
                >
                    <Button
                        variant="ghost_primary"
                        size="icon"
                        class="hover:text-foreground cursor-default"
                    >
                        &#8230;
                    </Button>
                </PaginationEllipsis>
            </template>
            <PaginationNext as-child>
                <Button
                    variant="ghost_primary"
                    size="icon"
                >
                    <ChevronRight />
                </Button>
            </PaginationNext>
        </PaginationList>
    </PaginationRoot>
</template>
